import axios from "axios";
import api from "../../../api/axios";
import { SERVER_URL } from "../../../ServerLink";

// Resident Notices API. Backend: Server/src/routes/resident-notice, mounted at /v2/resident-notices.
const BASE = "v2/resident-notices";

const data = (p) => p.then((r) => r.data);

/** Floors, units and counts for one building, for the audience picker. */
export const getNoticeOptions = (property_id, building_name) =>
  data(api.get(`${BASE}/options`, { params: { property_id, building_name: building_name || "" } }));

/** The caller's properties with their buildings (company-wide picker). */
export const getNoticeProperties = () => data(api.get(`${BASE}/properties`));

/** Who an audience definition reaches right now; nothing is saved. */
export const previewNoticeAudience = (payload) => data(api.post(`${BASE}/audience`, payload));

export const listNotices = (params) => data(api.get(BASE, { params }));
export const getNotice = (id) => data(api.get(`${BASE}/${id}`));
export const createNotice = (payload) => data(api.post(BASE, payload));
export const updateNotice = (id, payload) => data(api.patch(`${BASE}/${id}`, payload));
export const deleteNotice = (id) => data(api.delete(`${BASE}/${id}`));

/** Push one file to storage through the shared upload route and hand back { key, url, size }. */
export const uploadNoticeFile = async (file, onUploadProgress) => {
  const formData = new FormData();
  formData.append("documents", file);
  const res = await api.post("v2/master_sheet/documents/upload", formData, { onUploadProgress });
  const first = Array.isArray(res.data?.data) ? res.data.data[0] : null;
  if (!first?.key) throw new Error("Upload did not return a storage key");
  return first;
};
export const addNoticeAttachment = (id, { key, filename, size, mime, kind, poster_for }) =>
  data(api.post(`${BASE}/${id}/attachments`, { key, filename, size, mime, kind, poster_for }));
export const removeNoticeAttachment = (id, attachmentId) => data(api.delete(`${BASE}/${id}/attachments/${attachmentId}`));
export const getNoticeAttachmentUrl = (id, attachmentId) => data(api.get(`${BASE}/${id}/attachments/${attachmentId}/url`));

export const sendNoticeTest = (id) => data(api.post(`${BASE}/${id}/test`));
export const sendNotice = (id, scheduled_at) => data(api.post(`${BASE}/${id}/send`, scheduled_at ? { scheduled_at } : {}));
export const cancelNotice = (id) => data(api.post(`${BASE}/${id}/cancel`));
export const resendNotice = (id, only = "missed") => data(api.post(`${BASE}/${id}/resend`, { only }));
export const duplicateNotice = (id) => data(api.post(`${BASE}/${id}/duplicate`));

/** The resident's view. No login: the token is the authentication, so the bare client is used. */
export const getPublicNotice = (id, token) =>
  axios.get(`${String(SERVER_URL).replace(/\/+$/, "")}/v2/resident-notices/public/${id}/${token}`).then((r) => r.data);

/** The resident's view from a short link. No login: the code is the authentication. */
export const getPublicNoticeByCode = (code) =>
  axios.get(`${String(SERVER_URL).replace(/\/+$/, "")}/v2/resident-notices/public/link/${code}`).then((r) => r.data);

/** The notice as a resident will receive it: rendered email, text body, sample recipient. */
export const previewNotice = (id, payload) => data(api.post(`${BASE}/${id}/preview`, payload));

export const undoNoticeSend = (id) => data(api.post(`${BASE}/${id}/undo`));
export const nudgeNotice = (id, channel = "both") => data(api.post(`${BASE}/${id}/nudge`, { channel }));

export const listNoticeTemplates = () => data(api.get(`${BASE}/templates`));
export const createNoticeTemplate = (payload) => data(api.post(`${BASE}/templates`, payload));
export const deleteNoticeTemplate = (tid) => data(api.delete(`${BASE}/templates/${tid}`));
export const useNoticeTemplate = (tid) => data(api.post(`${BASE}/templates/${tid}/use`));

/** The resident pressing "Got it" on a notice that requires acknowledgement. No login. */
export const acknowledgeNotice = (code) =>
  axios.post(`${String(SERVER_URL).replace(/\/+$/, "")}/v2/resident-notices/public/link/${code}/acknowledge`).then((r) => r.data);
